import { colors, fonts, layout, spacing } from '../theme';

const styles = {
  container: {
    marginBottom: spacing.md,
  },
  label: {
    display: 'block',
    fontFamily: fonts.heading,
    fontSize: '0.9rem',
    fontWeight: 500,
    marginBottom: spacing.xs,
    color: colors.darkGray,
  },
  input: {
    fontFamily: fonts.body,
    fontSize: '1rem',
    height: '2.25rem',
    padding: '0.5rem',
    border: `1px solid ${colors.borderColor}`,
    borderRadius: layout.borderRadius,
    width: '100%',
    boxSizing: 'border-box',
    transition: 'all 0.2s ease',
    backgroundColor: colors.white,
    color: colors.darkGray,
    minHeight: '44px', // Touch-friendly
  },
  inputFocus: {
    outline: 'none',
    borderColor: colors.blue,
    boxShadow: `0 0 0 3px rgba(0, 99, 160, 0.1)`,
  },
  inputError: {
    borderColor: colors.error,
  },
  inputSuccess: {
    borderColor: colors.success,
  },
  helperText: {
    fontSize: '0.875rem',
    marginTop: spacing.xs,
    color: colors.midGray,
  },
  errorText: {
    fontSize: '0.875rem',
    marginTop: spacing.xs,
    color: colors.error,
  },
  required: {
    color: colors.error,
    marginLeft: spacing.xs,
  },
};

function Input({
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  error = null,
  helperText = null,
  required = false,
  disabled = false,
  fullWidth = true,
  style = {},
  className = '',
  id,
  name,
  'aria-label': ariaLabel,
  ...props
}) {
  const inputId = id || name || `input-${Math.random().toString(36).substr(2, 9)}`;
  const inputStyle = {
    ...styles.input,
    ...(error ? styles.inputError : {}),
    ...(value && !error ? styles.inputSuccess : {}),
    width: fullWidth ? '100%' : 'auto',
    ...style,
  };

  const handleFocus = (e) => {
    Object.assign(e.target.style, styles.inputFocus);
  };

  const handleBlur = (e) => {
    e.target.style.boxShadow = 'none';
  };

  return (
    <div style={styles.container} className={className}>
      {label && (
        <label htmlFor={inputId} style={styles.label}>
          {label}
          {required && <span style={styles.required}>*</span>}
        </label>
      )}
      <input
        id={inputId}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        style={inputStyle}
        onFocus={handleFocus}
        onBlur={handleBlur}
        aria-label={ariaLabel || label}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined}
        {...props}
      />
      {error && (
        <div id={`${inputId}-error`} style={styles.errorText} role="alert">
          {error}
        </div>
      )}
      {helperText && !error && (
        <div id={`${inputId}-helper`} style={styles.helperText}>
          {helperText}
        </div>
      )}
    </div>
  );
}

export default Input;

